module.exports = __webpack_public_path__ + "img/警徽拷贝2@2x.ea4cfcc2.png";